
import {
  defineComponent, ref, watch, computed
} from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import MemuTree from './menuTreeNode.vue';
// import {
//   MailOutlined, QqOutlined, AppstoreOutlined, SettingOutlined,
// } from '@ant-design/icons-vue';
// import { Icon } from '@/components/icon/inco';

export default defineComponent({
  props: {
    userSeletPath: String,
  },
  setup(props, context) {
    const store = useStore();
    const menu = computed(() => store.state.user.menu);
    const cachePath = computed(() => store.getters.cacheComponentsPath);
    let pre;
    let cur;
    let childPre;
    const selectedPath = ref('');
    let route;
    const selectedKeys = ref<string[]>([]);
    const openKeys = ref<string[]>([]);
    const hasChildRoute = {};
    const router = useRouter();
    const collapsed = ref(false);
    const showArrow = ref(false);
    useRouter().getRoutes().forEach((item, index) => {
      if (item.name === 'Dashboard') {
        route = item.children;
      }
      if (item.children && item.children.length > 0 && item.path !== '/dashboard') {
        item.children.forEach((subItem) => {
          hasChildRoute[subItem.path] = item.path;
          if (subItem.children) {
            subItem.children.forEach((secItem) => {
              hasChildRoute[secItem.path] = subItem.path;
            });
          }
        });
      }
    });
    const checkActiveMunu = (path) => {
      if (pre !== undefined) {
        pre.selected = false;
      }
      if (childPre !== undefined) {
        childPre.selected = false;
      }
      const openKeysArr = [];
      cur = menu.value.find((menuItem) => {
        let result;
        openKeysArr.length = 0;
        openKeysArr.push(menuItem.path);
        if (menuItem.children) {
          const child = menuItem.children.find((subItem) => {
            if (subItem.children) {
              // 优化项
              // openKeysArr.push(subItem.path);
              return subItem.children.find((secItem) => secItem.path === path);
            }
            return subItem.path === path;
          });
          result = child !== undefined ? child : undefined;
          if (result !== undefined) {
            result.selected = true;
            childPre = result;
          }
        }
        if (menuItem.path === path) {
          result = menuItem;
        }
        return result;
      });
      if (cur !== undefined) {
        openKeysArr.forEach((item) => {
          if (openKeys.value.findIndex((menuPath) => menuPath === item) === -1) {
            openKeys.value.push(item);
          }
        });
        cur.selected = true;
        pre = cur;
      }
    };

    const handleClick = (e: string) => {
      if (e === '/largescreenpanel') {
        const serverUrl = `${window.location.origin}/cloud/largescreenpanel`;
        const localUrl = `${window.location.origin}/#/largescreenpanel`;
        const url = process.env.NODE_ENV === 'production' ? serverUrl : localUrl;
        window.open(url);
        return;
      }
      router.push({ path: e, query: { fromOrigin: 'menu' } });
    };

    const selectItem = (item, key, selectedKey) => {
      if (item.key === '/largescreenpanel') {
        return;
      }
      selectedPath.value = item.key;
      let hasPath = false;
      cachePath.value.forEach((pathItem, index) => {
        if (pathItem === selectedPath.value) {
          hasPath = true;
        }
      });
      if (hasPath) {
        store.commit('DELETE_CACHE_COMPONENTS_PATH', selectedPath.value);
      } else {
        store.commit('SET_CACHE_COMPONENTS_PATH', selectedPath.value);
      }
      checkActiveMunu(selectedPath.value);
    };
    const toggleCollapsed = () => {
      collapsed.value = !collapsed.value;
      context.emit('toggleCollapsed', collapsed.value);
      store.commit('SET_MENU_SLIDE', collapsed.value);
      if (collapsed.value) {
        // openKeys.value.length = 0;
        // selectedKeys.value.length = 0;
      }
    };
    watch(() => props.userSeletPath, (val) => {
      if (val !== selectedKeys.value[0]) {
        selectedKeys.value.splice(0, 1, val);
        checkActiveMunu(val);
        // if (hasChildRoute[val]) {
        //   openKeys.value[0] = hasChildRoute[val];
        // }
      }
    });
    return {
      selectedKeys,
      openKeys,
      collapsed,
      selectedPath,
      menu,
      route,
      showArrow,
      toggleCollapsed,
      handleClick,
      selectItem,
    };
  },
  components: {
    MemuTree
    // Icon,
    // MailOutlined,
    // QqOutlined,
    // AppstoreOutlined,
    // SettingOutlined,
  },
});
